import React, { createContext } from "react";

const ConfigContext = React.createContext({
    config: {},
});

export default ConfigContext;
